/**
 * @file Wrapper component in AngularJS for React voiceAssistant enrollment page
 * @author Max van Loosbroek
 */

import template from './voiceAssistantEnrollmentPage.html'

const voiceAssistantEnrollmentPage = {
  bindings: {
    user: '<'
  },
  template,
  controller: /* @ngInject */ class VoiceAssistantEnrollmentPageController {
    constructor (StoreService, $state, $location) {
      this.StoreService = StoreService
      this.$state = $state
      this.$location = $location
      this.urlParams = this.$state.params
    }
  }
}

export default voiceAssistantEnrollmentPage
